export const getEmployeeKeyTooltipLabel = () =>
  'Unique key used by the company to identify each employee.';

export const getInvestorCoverageStatusTooltipLabel = () =>
  'Set to "Configured" when a matching employee key is found in your CRM data.';
